export const ResultPopoverId = 'RESULT_POPOVER';
